module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/companies-admin/company-new/company-new.component.css
// module id = ./src/app/companies-admin/company-new/company-new.component.css
// module chunks = main